import { Withdrawal } from '@shared/app/scripts/services/withdrawal';

/*
 * Service sendWithdrawal
 */
angular
  .module('posApp')
  .factory(
    'sendWithdrawal',
    (
      displayMessage: any,
      endOfShift: any,
      legacyPrint: any,
      mask: any,
      navigateTo: any,
      pos: any,
      translate: any,
      withdrawal: Withdrawal,
    ) => {
      const $translate = translate;

      return function sendWithdrawal(transaction: any) {
        // link the shift if EOS is used, store receipt in the spynl api
        endOfShift.setShiftCycleId(transaction);

        withdrawal.add(transaction).then(
          (addIds) => {
            if (!addIds || addIds[0].length === 0) {
              const message = $translate.instant('TransactionNotSuccessful');
              displayMessage.message(message);
              return;
            }

            legacyPrint
              .withdrawal(transaction, pos.config)
              .then(angular.noop, () => {
                displayMessage.message({
                  message: $translate.instant('PrintingFailed'),
                  type: 'errorprompt',
                  ok: true,
                  callback: null,
                });
                navigateTo('pos.route#more');
              })
              .then(mask.hide, mask.hide);

            // go to main
            navigateTo('pos.route#main');
            pos.selectedMenu = 1;
          },
          () => {
            const message = $translate.instant('TransactionNotSuccessful');
            displayMessage.message(message);
            return;
          },
        );
      };
    },
  );
